// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltTwoToneSvg from "@fishx/icons-svg/es/asn/ThunderboltTwoTone";
import FishxIcon from '../components/FishxIcon';

var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltTwoToneSvg
  }));
};

ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
export default React.forwardRef(ThunderboltTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ThunderboltTwoTone.js
// module id = 4262
// module chunks = 0